import { Grid, Typography, Tooltip, Accordion, Card } from "@mui/material";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { useState, useEffect, useContext, useRef } from "react";
import { BreadcrumbContext } from "../../contexts/breadcrumb";
import { AppLayout } from "../../layouts/app";
import { TrackerRelationshipsService } from "../../services/trackerRelationships";
import { DataGridDetails } from "../../components/dataGridDetails";
import moment from "moment-timezone";
import KeyRoundedIcon from '@mui/icons-material/KeyRounded';
import SpeedRoundedIcon from '@mui/icons-material/SpeedRounded';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCarBattery } from "@fortawesome/free-solid-svg-icons";
import SensorDoorRoundedIcon from '@mui/icons-material/SensorDoorRounded';
import AcUnitRoundedIcon from '@mui/icons-material/AcUnitRounded';
import BatteryChargingFullRoundedIcon from '@mui/icons-material/BatteryChargingFullRounded';
import SquareRoundedIcon from '@mui/icons-material/SquareRounded';
import NoMonitorated from "../../assets/nao-monitoramentoN.png";
import Origin from "../../assets/nao-monitoramentoO.png";
import Destiny from "../../assets/monitoramentoD.png";
import Path from "../../assets/monitoramentoC.png";
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';
import { Maps } from "../../components/GoogleMap";
import eggs from "../../assets/egg.png";
import chicken from "../../assets/chick.png";
import embryo from "../../assets/embriao.png";
import no_image from "../../assets/sem_imagem.png";

export const GridDetails = () => {
  const [breadcrumbs, setBreadcrumbs] = useContext(BreadcrumbContext);
  const trackerRelationshipsService = new TrackerRelationshipsService();
  const [data, setData] = useState([]);
  const [firstTimeLoading, setFirstTimeLoading] = useState(true);
  const updaterRef = useRef(null);
  const [heightMaps, setHeightMaps] = useState("60vh");
  const [positions, setPositions] = useState([]);
  const [trackerRelationShipIdSelected, setTrackerRelationShipIdSelected] = useState(null);
  const [positionAndPlateSelected, setPositionAndPlateSelected] = useState(null);
  const [isLoadPoints, setIsLoadPoints] = useState(false);

  const TIME_UPDATE_INFO_GRID = 60000;

  useEffect(() => {
    const breadcrumbs = [];
    let interval;
    getGridInformation();
    interval = setInterval(() => {
      getGridInformation();
    }, TIME_UPDATE_INFO_GRID);
    setBreadcrumbs(breadcrumbs);


    return () => {
      clearInterval(interval);
    }
  }, []);

  const stopUpdater = () => {
    clearInterval(updaterRef.current);
    updaterRef.current = null;
  };

  const columns = [
    {
      field: "vehiclePlate",
      headerAlign: "center",
      align: "center",
      headerClassName: "super-app-theme--header",
      headerName: (
        <Typography
          sx={{ fontSize: "14px", color: "white", fontWeight: "bold" }}
          component="div"
          align="center"
        >
          Placa
        </Typography>
      ),
      minWidth: 150,
      width: 150,
      filterable: false,
      renderCell: ({ row }) => (
        <Tooltip title={row.vehiclePlate}>
          <span style={{ fontSize: row.vehiclePlate.length > 7 ? '12px' : '16px' }}>{row.vehiclePlate}</span>
        </Tooltip>
      ),
    },
    {
      field: "typeOperation",
      headerAlign: "center",
      align: "center",
      headerClassName: "super-app-theme--header",
      headerName: (
        <Typography
          sx={{ fontSize: "14px", color: "white", fontWeight: "bold" }}
          component="div"
          align="center"
        >
          Tipo de
          <br />
          Operação
        </Typography>
      ),
      minWidth: 110,
      width: 110,
      filterable: true,
      renderCell: ({ row }) => (
        row.typeOperation === "OVOS" ? (
          <img
            src={eggs}
            alt="Ícone"
            style={{
              width: "20px",
              height: "20px",
              marginRight: "5px",
            }}
          />
        ) : row.typeOperation === "PINTOS" ?
          (
            <img
              src={chicken}
              alt="Ícone"
              style={{ width: "25px", height: "25px" }}
            />
          ) : row.typeOperation === "EMBRIÕES" ? (
            <img
              src={embryo}
              alt="Ícone"
              style={{ width: "19px", height: "19px", marginRight: "5px" }}
            />
          ) :
            <img
              src={no_image}
              alt="Ícone"
              style={{ width: "25px", height: "25px" }}
            />
      )
    },
    {
      field: "status",
      headerAlign: "center",
      align: "center",
      headerClassName: "super-app-theme--header",
      headerName: (
        <Tooltip title={"Monitorado ou Não Monitorado"}>
          <Typography
            sx={{ fontSize: "14px", color: "white", fontWeight: "bold" }}
            component="div"
            align="center"
          >
            Status
          </Typography>
        </Tooltip>
      ),
      minWidth: 65,
      width: 65,
      filterable: false,
      renderCell: ({ row }) =>
        row.status === 0 ? (
          <img
            src={Origin}
            alt="Ícone"
            style={{ width: "43px" }}
            title="Na Origem"
          />
        ) : row.status === 1 ? (
          <img
            src={Path}
            alt="Ícone"
            style={{ width: "43px" }}
            title="A Caminho"
          />
        ) : row.status === 2 ? (
          <img
            src={Destiny}
            alt="Ícone"
            style={{ width: "43px" }}
            title="No Destino"
          />
        ) : (
          <img
            src={NoMonitorated}
            alt="Ícone"
            style={{ width: "43px" }}
            title="Não Monitorado"
          />
        ),
    },
    {
      field: "dateTimeLastUpdate",
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      headerName: (
        <Typography
          sx={{ fontSize: "14px", color: "white", fontWeight: "bold" }}
        >
          Data/Hora
        </Typography>
      ),
      minWidth: 175,
      flex: 1,
      filterable: false,
      align: "center",
      renderCell: ({ row }) => {
        const currentTime = moment();

        const lastUpdateTime = moment(row.dateTimeLastUpdate);

        const hoursDifference = currentTime.diff(lastUpdateTime, "hours");

        const color =
          hoursDifference < 24
            ? "green"
            : hoursDifference < 48
              ? "#EAE019"
              : hoursDifference < 120
                ? "orange"
                : "red";

        return (
          <div>
            {moment(row.dateTimeLastUpdate).format("DD/MM/YYYY HH:mm:ss")}
            <SquareRoundedIcon
              sx={{
                marginLeft: "10px",
                fontSize: "10px",
                color: color,
              }}
            />
          </div>
        );
      },
    },
    {
      field: "ignition",
      headerAlign: "center",
      align: "center",
      headerClassName: "super-app-theme--header",
      headerName: (
        <Tooltip title={"Iginição"}>
          <KeyRoundedIcon
            fontSize="small"
            sx={{ color: "#FFFFFF", marginBottom: "-4px" }}
          />
        </Tooltip>
      ),
      minWidth: 75,
      flex: 1,
      filterable: false,
      renderCell: ({ row }) =>
        row.ignition ? (
          <KeyRoundedIcon fontSize="small" style={{ color: "green" }} />
        ) : (
          <KeyRoundedIcon fontSize="small" style={{ color: "red" }} />
        ),
    },
    {
      field: "vehicleSpeed",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      headerName: (
        <Tooltip title={"Velocidade (km/h)"}>
          <SpeedRoundedIcon
            fontSize="small"
            sx={{ color: "#FFFFFF", marginBottom: "-4px" }}
          />
        </Tooltip>
      ),
      minWidth: 75,
      flex: 1,
      filterable: false,
      renderCell: ({ row }) => row.vehicleSpeed.toFixed(2),
    },
    {
      field: "powerVoltage",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      headerName: (
        <Tooltip title={"Bateria Veículo (V)"}>
          <FontAwesomeIcon
            fontSize={"19px"}
            color="white"
            icon={faCarBattery}
          ></FontAwesomeIcon>
        </Tooltip>
      ),

      minWidth: 75,
      flex: 1,
      filterable: false,
      renderCell: ({ row }) => Number.parseFloat(row.powerVoltage).toFixed(2),
    },
    {
      field: "trunkVoltage",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      headerName: (
        <Tooltip title={"Bateria Bau (V)"}>
          <BatteryChargingFullRoundedIcon
            fontSize="medium"
            sx={{
              color: "#FFFFFF",
              transform: "rotate(90deg)",
              marginTop: "23px",
            }}
          />
        </Tooltip>
      ),
      minWidth: 75,
      flex: 1,
      filterable: false,
      renderCell: ({ row }) => Number.parseFloat(row.trunkVoltage).toFixed(2),
    },
    {
      field: "isDoorOpen",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      headerName: (
        <Tooltip title={"Porta"}>
          <SensorDoorRoundedIcon
            sx={{
              marginTop: "20px",
              color: "white",
              width: "19px",
              height: "19px",
            }}
          ></SensorDoorRoundedIcon>
        </Tooltip>
      ),
      minWidth: 75,
      flex: 1,
      filterable: false,
      renderCell: ({ row }) =>
        row.isDoorOpen ? (
          <SensorDoorRoundedIcon
            style={{ color: "green", width: "19px", height: "19px" }}
          />
        ) : (
          <SensorDoorRoundedIcon
            style={{ color: "red", width: "19px", height: "19px" }}
          />
        ),
    },
    {
      field: "thermoKing",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      headerName: (
        <Tooltip title={"Climatização"}>
          <AcUnitRoundedIcon
            fontSize="small"
            sx={{ marginTop: "20px", color: "white" }}
          ></AcUnitRoundedIcon>
        </Tooltip>
      ),
      minWidth: 75,
      flex: 1,
      filterable: false,
      renderCell: ({ row }) =>
        row.thermoKing == "OFF" ? (
          <AcUnitRoundedIcon fontSize="small" />
        ) : row.thermoKing == "ON" ? (
          <AcUnitRoundedIcon fontSize="small" style={{ color: "green" }} />
        ) : (
          <AcUnitRoundedIcon fontSize="small" style={{ color: "red" }} />
        ),
    },
    {
      field: "temperatureExt",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      headerName: (
        <Typography
          sx={{ fontSize: "12px", color: "white", fontWeight: "bold" }}
          component="div"
          align="center"
        >
          Temp.
          <br />
          Externa (ºC)
        </Typography>
      ),
      minWidth: 100,
      flex: 1,
      filterable: false,
      renderCell: ({ row }) => row.temperatureExt.toFixed(2),
    },
    {
      field: "temperatureInt1",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      headerName: (
        <Typography
          sx={{ fontSize: "12px", color: "white", fontWeight: "bold" }}
          component="div"
          align="center"
        >
          Temp.
          <br />
          Interna 1 (ºC)
        </Typography>
      ),
      minWidth: 100,
      flex: 1,
      filterable: false,
      renderCell: ({ row }) => row.temperatureInt1.toFixed(2),
    },
    {
      field: "temperatureInt2",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      headerName: (
        <Typography
          sx={{ fontSize: "12px", color: "white", fontWeight: "bold" }}
          component="div"
          align="center"
        >
          Temp.
          <br />
          Interna 2 (ºC)
        </Typography>
      ),
      minWidth: 100,
      flex: 1,
      filterable: false,
      renderCell: ({ row }) => row.temperatureInt2.toFixed(2),
    },
    {
      field: "humidity1",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      headerName: (
        <Typography
          sx={{ fontSize: "12px", color: "white", fontWeight: "bold" }}
          component="div"
          align="center"
        >
          Umid.
          <br />
          Interna 1 (%)
        </Typography>
      ),
      minWidth: 105,
      flex: 1,
      filterable: false,
      renderCell: ({ row }) => row.humidity1.toFixed(2),
    },
    {
      field: "humidity2",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      headerName: (
        <Typography
          sx={{ fontSize: "12px", color: "white", fontWeight: "bold" }}
          component="div"
          align="center"
        >
          Umid.
          <br />
          Interna 2 (%)
        </Typography>
      ),
      minWidth: 105,
      flex: 1,
      filterable: false,
      renderCell: ({ row }) => row.humidity2.toFixed(2),
    },
    {
      field: "firstCo2",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      headerName: (
        <Typography
          sx={{ fontSize: "12px", color: "white", fontWeight: "bold" }}
          component="div"
          align="center"
        >
          CO2 (PPM)
        </Typography>
      ),
      minWidth: 105,
      flex: 1,
      filterable: false,
      renderCell: ({ row }) => row.firstCo2.toFixed(2),
    },
    {
      field: "vibration1",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      headerName: (
        <Typography
          sx={{ fontSize: "14px", color: "white", fontWeight: "bold" }}
          component="div"
          align="center"
        >
          Vibração (G)
        </Typography>
      ),
      minWidth: 105,
      flex: 1,
      filterable: false,
      renderCell: ({ row }) => row.vibration1.toFixed(2),
    },
    {
      field: "latitude",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      headerName: (
        <Typography
          sx={{ fontSize: "14px", color: "white", fontWeight: "bold" }}
          component="div"
          align="center"
        >
          Latitude
        </Typography>
      ),
      minWidth: 105,
      flex: 1,
      filterable: false,
      renderCell: ({ row }) => Number.parseFloat(row.latitude).toFixed(6),
    },

    {
      field: "longitude",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      headerName: (
        <Typography
          sx={{ fontSize: "14px", color: "white", fontWeight: "bold" }}
          component="div"
          align="center"
        >
          Longitude
        </Typography>
      ),
      minWidth: 150,
      flex: 1,
      filterable: false,
      renderCell: ({ row }) => Number.parseFloat(row.longitude).toFixed(6),
    },
  ];

  const handleResponseData = (data) => {
    setData(data);
    if (firstTimeLoading) {
      setTimeout(() => {
        setFirstTimeLoading(false);
      }, 100);
    }
  };

  const getGridInformation = () => {
    trackerRelationshipsService
      .getGridView()
      .then((response) => {
        handleResponseData(response.data);
        let values = [];
        response.data.forEach((element) => {
          values.push({
            lat: parseFloat(element.latitude),
            lng: parseFloat(element.longitude),
            plate: element.vehiclePlate,
          });
        });
        setPositions(values);
      })
      .catch((error) => {
        stopUpdater();
      });
  };

  const handleIsLoadPoints = (isloadPoints) => {
    setIsLoadPoints(isloadPoints);
  };

  const handleChangeHeight = (event, expanded) => {
    if (!expanded) setHeightMaps("92vh");
    else setHeightMaps("60vh");
  };

  const handleSetPositionAndPlate = (position, plate) => {
    setPositionAndPlateSelected({
      lat: parseFloat(position.latitude),
      lng: parseFloat(position.longitude),
      plate: plate,
    });
  };

  const handleSetTrackerRelationshipId = (trackerRelationshipsId) => {
    setTrackerRelationShipIdSelected(trackerRelationshipsId);
  };

  const configAccordionSummary = {
    minHeight: "30px",
    "&.Mui-expanded": {
      minHeight: "30px",
    },
    ".MuiAccordionSummary-content": {
      margin: 0,
    },
    ".MuiAccordionSummary-content.Mui-expanded": {
      margin: 0,
    },
    ".MuiAccordionSummary-expandIconWrapper": {
      padding: 0,
    },
    ".MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
      padding: 0,
    },
    "& .MuiTypography-root": {
      fontSize: "12px",
      lineHeight: "20px",
    },
    marginRight: "65px",
    zIndex: 1,
  };

  const configGridAndMap = {
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
    position: "fixed",
    top: 0,
    left: 0,
  };


  return (
    <AppLayout collapsed={true} id={"teste"} isGridDetails={true}>
      <Grid container direction="column" style={configGridAndMap}>
        <Grid item style={{ flex: "3 1 0%", marginLeft: "58px" }}>
          <Card style={{ height: "100%" }}>
            <Maps
              height={heightMaps}
              latLong={positions}
              latLongAndPlateSelected={positionAndPlateSelected}
              trackerRelationshipsId={trackerRelationShipIdSelected}
              isLoadPoints={handleIsLoadPoints}
            />
          </Card>
        </Grid>

        <Grid
          item
          xl={12}
          xs={12}
          style={{ flex: "2 1 0%", marginLeft: "43px" }}
        >
          <Accordion
            defaultExpanded
            sx={{
              width: "100vw",
            }}
            onChange={handleChangeHeight}
          >
            <AccordionSummary
              expandIcon={<ArrowDropUpRoundedIcon fontSize={"large"} />}
              aria-controls="panel2-content"
              id="panel2-header"
              sx={configAccordionSummary}
            ></AccordionSummary>
            <AccordionDetails>
              <DataGridDetails
                loadingData={firstTimeLoading}
                data={data}
                columns={columns}
                position={handleSetPositionAndPlate}
                trackerRelationshipId={handleSetTrackerRelationshipId}
              />
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </AppLayout>
  );
};
